import basicController from "servicestack/basic.controller.properties";
import ServiceBus from "servicestack/service-bus";

export default class ZipcodeParserController {
  constructor(options) {
    console.debug("ZipcodeParserController", { that: this, options });
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.selected = {};
    Object.assign($ctrl, options);
    $ctrl.bus = new ServiceBus();
  }

  submit() {
    const $ctrl = this;
      const IdIn = ($ctrl.zipcodeIds || "NO_ZIPCODE_ID").split(/[\s,]+/gi).filter(zipcodeid => !!zipcodeid);
    const request = {
      IdIn,
      take: 500,
      fields: "Id"
    };
    $ctrl.bus.send("QueryZipcodes.json", request).then(({ data }) => {
      $ctrl.$close(data.results.map(p => p.id));
    });
  }

  $onDestroy() {
    this.bus.dispose();
  }
}
